import type { AgGridRowData, AgGridTransactionRef } from './types';

export const deleteTransaction = (
  newRows: AgGridRowData[] | null | undefined,
  gridRef: AgGridTransactionRef | null | undefined
): AgGridRowData[] => {
  const api = gridRef?.current?.api;
  if (api && newRows && Array.isArray(newRows)) {
    api.applyServerSideTransaction({
      remove: newRows
    });
    return newRows;
  } else return [];
};
